import React, { useState, useEffect } from "react";
import ReactRouter from "./components/AppRouter";
import "./style/app.css"

function App() {

  return (
    <>
      <ReactRouter />
    </>
  )
}

export default App;
